import { render, staticRenderFns } from "./AbkPairedOffersBox.vue?vue&type=template&id=73594d70&scoped=true&"
import script from "./AbkPairedOffersBox.vue?vue&type=script&lang=js&"
export * from "./AbkPairedOffersBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkPairedOffersBox.vue?vue&type=style&index=0&id=73594d70&scoped=true&lang=scss&"
import style1 from "./AbkPairedOffersBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73594d70",
  null
  
)

export default component.exports